import { render, staticRenderFns } from "./IntegracaoContaForm.vue?vue&type=template&id=b51277a0"
import script from "./IntegracaoContaForm.vue?vue&type=script&lang=js"
export * from "./IntegracaoContaForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports